import axios from 'axios'

const API_PATH = 'api/v2/admins/products/attributes/brand_classifications'

const ProductAttributeBrandClassificationsApiV2 = {
  /**
   * Get list of `Product Brand Classifications`
   * @param {object} params uri parameter
   * @return {object} Collection of `Filtered Brand Classification`
   */
  get: async (name) => {
    const params   = { name: name }
    const path     = API_PATH
    const response = axios.get(path, { params })
    return response
  }
}

export default ProductAttributeBrandClassificationsApiV2
